
export default function Features() {
  const features = [
    {
      icon: 'ri-truck-line',
      title: 'Hızlı Tedarik',
      description: 'Geniş tedarikçi ağımız ve etkin lojistik sistemimizle ihtiyaçlarınızı hızla karşılıyoruz.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Kalite Güvencesi',
      description: 'Sadece sertifikalı üreticilerden temin ettiğimiz, kalite kontrollü ürünlerle çalışıyoruz.'
    },
    {
      icon: 'ri-search-line',
      title: 'Geniş Ürün Yelpazesi',
      description: 'Endüstriyel ihtiyaçlarınız için kapsamlı bağlantı elemanı çeşitleri sunuyoruz.'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Uzman Destek',
      description: 'Deneyimli ekibimizle teknik danışmanlık ve müşteri desteği sağlıyoruz.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 
            className="text-4xl md:text-5xl font-bold text-slate-800 mb-4"
            style={{ fontFamily: 'Exo 2, sans-serif' }}
          >
            Neden NBA Cıvata?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Endüstriyel bağlantı elemanlarında güvenilir tedarik ortağınız
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-16 h-16 bg-orange-100 rounded-lg flex items-center justify-center mb-6 mx-auto">
                <i className={`${feature.icon} text-2xl text-orange-500`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-800 mb-4 text-center">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-center leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}